exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mt-4[data-v-1bad4daa]{margin-top:1.5rem}.mb-2[data-v-1bad4daa]{margin-bottom:.5rem}.mb-4[data-v-1bad4daa]{margin-bottom:1.5rem}.h-100[data-v-1bad4daa]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bad4daa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/expenseTableExample.vue
// module id = 1413
// module chunks = 0